<template>
  <v-btn
    x-small
    outlined
    color="secondary"
    @click="showControl = true"
  >
    Show State
    <v-dialog
      v-if="device"
      v-model="showControl"
      max-width="480px"
    >
      <videon-card heading="Decoder State" showClose="true" @close="showControl = false">
        <v-card-text>
          
          <recursive-label :content="device.state.decoder_info" style="overflow: auto; max-height: 300px;" class="mb-3" />
          
          <div class="text-right">
            <v-btn
              class="ma-1"
              color="primary"
              @click="showControl = false"
            >
              Close
            </v-btn>
          </div>
        </v-card-text>
      </videon-card>
    </v-dialog>
  </v-btn>
</template>

<script>
  export default {
    name: 'BirdDogDebug',
    
    props: ['device'],
    
    data() {
      return {
        showControl: false,
      }
    },
    
    methods: {
      
    }
  }
</script>